import { Children, type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsFooter = (props: Props) => {
  const { shouldFitActionsInRow, children } = props;

  const { match } = useResponsive();

  // ─── Derived ─────────────────────────────────────────────────────────

  const shouldUseRow = shouldFitActionsInRow || match([false, true]);
  const actionsGap = match([theme.spacing['2'], theme.spacing['3']]);

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerGapStyles = useStyle(() => ({ gap: actionsGap }), [actionsGap]);
  const containerStyles = [
    styles.container,
    shouldUseRow ? styles.containerRow : undefined,
    containerGapStyles,
  ];
  const actionStyles = shouldUseRow ? styles.action : undefined;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles}>
      {Children.map(children, (action) => (
        <View style={actionStyles}>{action}</View>
      ))}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    marginTop: theme.spacing['8'],
  },
  containerRow: {
    flexDirection: 'row',
  },
  action: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  shouldFitActionsInRow?: boolean;
}>;
